import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import {useState } from 'react';
import { IconButton } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

const style = {
  bgcolor:'#12B6EA',
  borderRadius:'10px',
  fontWeight:'700',
  fontSize:'14px',
  fontFamily:'inter',
  fontStyle:'normal',
  padding:'11px 28px'
}

interface FreeTrialPopupProps {
  show: boolean,
  title: string,
  desc:string,
  btnTitle: string,
  isError:boolean
}

export const FreeTrialPopup = ({show,title,desc,btnTitle,isError}:FreeTrialPopupProps) => {
  const [open, setOpen] = useState(show);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="free-trial-popup" sx={{outline:'none'}}>
          <Box className={`free-trial-popup-bg ${isError && 'error'}`} sx={{width:'100%',height:'100%'}}>
            {
              isError &&
              <IconButton aria-label="close" color='inherit' 
                  sx={{position:'absolute',top:'16px',right: { xs: '16px'}}} onClick={handleClose}>
                  <ClearIcon />
                </IconButton>
            }
            <Typography id="modal-modal-title" variant="h6" component="h2">
            {title}
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
           {desc}
          </Typography>
          <Box sx={{
            display:'flex',
            alignItems:'center',
            flexDirection:'column'}}>
            <Button className='start-btn' variant="contained" 
            sx={style}>{btnTitle}</Button>
            <Typography
            sx={{...style, bgcolor:'transparent',color:'#12B6EA',cursor:'pointer'}}>
              Learn more
            </Typography>
          </Box>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}